import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { PassLike } from '../models';
import { Invitation } from '../models/Invitation';
import { PassesAnimations } from '../passes/passes.animations';
import { DataService } from '../services/data-service';
import { ScreenService } from '../services/screen.service';
@Component({
	selector: 'sp-pass-requests-sidebar',
	templateUrl: './pass-requests-sidebar.component.html',
	styleUrls: ['./pass-requests-sidebar.component.scss'],
	animations: [
		PassesAnimations.TeacherOpenOrCloseRequests,
		PassesAnimations.StudentOpenOrCloseRequests,
		PassesAnimations.PassesSlideTopBottom,
		PassesAnimations.RequestCardSlideInOut,
		PassesAnimations.HeaderSlideInOut,
		PassesAnimations.HeaderSlideTopBottom,
		PassesAnimations.PreventInitialChildAnimation,
	],
})
export class PassRequestsSidebarComponent implements AfterViewChecked {
	showInboxAnimated() {
		return this.dataService.inboxState;
	}

	@ViewChild('tabGroup', { read: MatTabGroup, static: false }) tabGroup!: MatTabGroup;
	@ViewChild('spNowPassWrapper', { read: ElementRef, static: false }) spNowPassWrapper!: ElementRef;
	@ViewChild('spScheduledPassWrapper', { read: ElementRef, static: false }) spScheduledPassWrapper!: ElementRef;
	constructor(public screenService: ScreenService, public dataService: DataService, private cdr: ChangeDetectorRef) {
		this.windowHeight = window.innerHeight;
		this.updateHeight();
	}

	@Input() isStaff = false;
	@Input() nowRequests: Request[] | Invitation[] = [];
	@Input() scheduledRequests: Request[] | Invitation[] = [];
	@Input() receivedRequests2: Request[] | Invitation[] = [];
	@Input() activeTabIndex = 0;
	@Input() sortIconData: any;
	@Input() emptyPassRequestMessage: { image: string; text: string };
	@Input() _showRequestTitles: boolean;
	@Input() isStudent = false;
	@Input() toggleSortPreference: () => void = () => {};
	@Input() dismissNux: () => void = () => {};
	@Input() updateEmptyMessage: () => void = () => {};
	@Input() passesLoaded = false;

	@Output() openPassDialog = new EventEmitter<{ pass: PassLike; fromClick: boolean; fromEndButton: boolean }>();

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.updateHeight();
		this.cdr.detectChanges();
	}

	needsScroll = false;
	private newHeight = window.innerHeight - 214;
	private contentHeight = 1;
	windowHeight: number;

	private updateHeight() {
		this.windowHeight = document.body.clientHeight;
	}

	ngAfterViewChecked(): void {
		this.setTabBodyHeight();
		if (this.spNowPassWrapper || (this.spScheduledPassWrapper && !this.needsScroll)) {
			this.isScrollNeeded();
		}
	}

	updateActiveTab(event): void {
		this.activeTabIndex = event;
		this.updateEmptyMessage();
		this.setTabBodyHeight();
	}

	/* These methods are being used to compare the height of the now and scheduled sp-pass-encapsulation classes against
  the mat-tab-body-wrapper to set a ngClass on mat-tab-wrapper which controls whether the overflow-y is set to either hidden or auto  */
	private isScrollNeeded(): void {
		if (this.isStaff) {
			let wrapperElement: ElementRef;
			if (this.activeTabIndex === 0 && this.spNowPassWrapper) {
				wrapperElement = this.spNowPassWrapper;
			} else if (this.activeTabIndex === 1 && this.spScheduledPassWrapper) {
				wrapperElement = this.spScheduledPassWrapper;
			}
			if (wrapperElement) {
				const contentHeight = wrapperElement.nativeElement.getBoundingClientRect().height;
				if (contentHeight !== this.contentHeight) {
					if (contentHeight >= this.newHeight) {
						this.needsScroll = true;
						this.cdr.detectChanges();
					} else {
						this.needsScroll = false;
						this.cdr.detectChanges();
					}
				}
				this.contentHeight = contentHeight;
			}
		}
	}

	private setTabBodyHeight() {
		if (this.isStaff) {
			const tabBodyWrapper = (this.tabGroup as any)._tabBodyWrapper;
			const height = this.tabGroup._tabBodyWrapper.nativeElement.getBoundingClientRect().height;
			const top = this.tabGroup._tabBodyWrapper.nativeElement.getBoundingClientRect().top;
			this.newHeight = window.innerHeight - top;
			if (height !== this.newHeight && tabBodyWrapper) {
				if (this.newHeight < window.innerHeight) {
					tabBodyWrapper.nativeElement.style.height = `${this.newHeight}px`;
				}
			} else if (this.needsScroll === false) {
				tabBodyWrapper.nativeElement.style.height = `${this.windowHeight - top}px`;
			}
		}
	}
}
